import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { StickerButton, OutlineButton } from "../../globalStyles";
import mascot from "../../images/basakansoft.png";
import {
  HeroContainer,
  HeroInner,
  HeroText,
  HeroHeading,
  HeroSubtitle,
  HeroLinks,
  HeroMascot,
} from "./CompanySection.elements";

const RECRUITING_URL = "https://recruiting.basakansoft.com";

const CompanySection = () => {
  const [language, setLanguage] = useState("ko");
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/en") {
      setLanguage("en");
    } else if (location.pathname === "/ko") {
      setLanguage("ko");
    } else {
      const savedLang = localStorage.getItem("language") || "ko";
      setLanguage(savedLang);
    }

    const handleLanguageChange = (e) => setLanguage(e.detail);
    window.addEventListener("languageChange", handleLanguageChange);
    return () =>
      window.removeEventListener("languageChange", handleLanguageChange);
  }, [location.pathname]);

  const content = {
    ko: {
      heading: "세상에 아직 없던 게임을 만듭니다",
      subtitle:
        "바삭한소프트는 자체 기술력 기반 참신한 기획과 빠른 실행으로 전 세계 유저에게 새로운 경험을 선사하는 게임 스튜디오입니다.",
      games: "만드는 게임 보기",
      careers: "채용 안내",
    },
    en: {
      heading: "We build games that don't exist yet",
      subtitle:
        "Basakansoft is a game studio delivering new experiences to players worldwide through proprietary technology, original ideas, and fast execution.",
      games: "See our games",
      careers: "Careers",
    },
  };

  const c = content[language];

  return (
    <HeroContainer id="home">
      <HeroInner>
        <HeroText>
          <HeroHeading>{c.heading}</HeroHeading>
          <HeroSubtitle>{c.subtitle}</HeroSubtitle>
          <HeroLinks>
            <StickerButton href="#products">{c.games}</StickerButton>
            <OutlineButton href={RECRUITING_URL} target="_blank" rel="noreferrer">
              {c.careers}
            </OutlineButton>
          </HeroLinks>
        </HeroText>
        <HeroMascot aria-hidden="true">
          <img src={mascot} alt="" />
        </HeroMascot>
      </HeroInner>
    </HeroContainer>
  );
};

export default CompanySection;
